import { render, staticRenderFns } from "./restaurant_tables.vue?vue&type=template&id=668c7cc4&scoped=true&"
import script from "./restaurant_tables.vue?vue&type=script&lang=js&"
export * from "./restaurant_tables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c7cc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668c7cc4')) {
      api.createRecord('668c7cc4', component.options)
    } else {
      api.reload('668c7cc4', component.options)
    }
    module.hot.accept("./restaurant_tables.vue?vue&type=template&id=668c7cc4&scoped=true&", function () {
      api.rerender('668c7cc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/tables/restaurant_tables.vue"
export default component.exports